import { Box }            from '@chakra-ui/react';
import { Card }           from '@chakra-ui/react';
import { Center }         from '@chakra-ui/react';
import ClockIcon          from '@/assets/icons/ClockIcon';
import EntertainmentModel from '@/models/services/fondations/EntertainmentModel';
import Image              from '@/components/Image/Image';
import { Link }           from 'react-router-dom';
import { Separator }      from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import dayjs              from 'dayjs';
import isBetween          from 'dayjs/plugin/isBetween';
import useExtractColors   from '@/hooks/useExtraColors';
import { useTranslation } from 'react-i18next';

dayjs.extend(isBetween);

interface IEntertainmentCardProps {
	entertainment: EntertainmentModel;
}

const EntertainmentCard = ({ entertainment }: IEntertainmentCardProps) => {

	const { t, i18n } = useTranslation();

	const entertainmentIsHappeningNow = dayjs().isBetween(entertainment.dateStart, entertainment.dateEnd, 'day', '[]');
	const isLastingOneDay = dayjs(entertainment.dateStart).isSame(dayjs(entertainment.dateEnd));
	const {
		primaryColor = {
			red: '',
			green: '',
			blue: '',
		},
	} = useExtractColors(entertainment.logoUrl);


	return (
		<Card.Root
			variant="elevated"
			minWidth="300px"
			overflow="hidden"
		>
			<Box
				padding="20px"
				display="flex"
				justifyContent="center"
				alignItems="center"
				gap="20px"
				background={`linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(${primaryColor.red},${primaryColor.green},${primaryColor.blue},0.10) 100%)`}
			>
				<Box
					width="50px" 
					height="50px"
				>
					<Image errorSize='xl' borderRadius="md" src={entertainment.logoUrl} />
				</Box>
				<Box
					display="flex"
					flexDirection="column"
					gap="5px"
				>
					<Text className="poppins-semibold" fontSize="16px">{entertainment.translations[i18n.language]?.title}</Text>
					{
						isLastingOneDay ? (
							<Text fontSize="14px">
								{t(
									'pages.home.events.day',
									{
										day: dayjs(entertainment.dateStart).format('D'),
										month: dayjs(entertainment.dateStart).format('MMMM'),
										year: dayjs(entertainment.dateStart).format('YYYY'),
									},
								)}
							</Text>
						) : (
							<Text fontSize="14px">
								{(() => {
									const start = dayjs(entertainment.dateStart);
									const end = dayjs(entertainment.dateEnd);

									const sameMonth = start.isSame(end, 'month');

									const fromLabel = sameMonth
										? start.format('D')
										: start.format('D MMMM');

									const toLabel = end.format('D MMMM');

									return t(
										'pages.home.events.date',
										{
											fromDay: fromLabel,
											toDay: toLabel,
											year: start.format('YYYY'),
										},
									);
								})()}
							</Text>
						)
					}
				</Box>
			</Box>
			<Separator />
			<Center>
				{
					entertainmentIsHappeningNow ?
						<Link to="">
							<Text
								className="poppins-semibold"
								color="#2B2B2B"
								fontSize="14px"
								padding="20px"
								textDecoration="underline"
							>
								{t('pages.home.events.actions.join')}
							</Text>
						</Link>
						:
						<Box
							padding="20px"
							display="flex"
							alignItems="center"
							gap="10px"
						>
							<ClockIcon color="#A7A8A7" fontSize="20px" />
							<Text
								className="poppins-semibold"
								color={`rgba(${primaryColor.red},${primaryColor.green},${primaryColor.blue}, 1)`}
								fontSize="20px"
							>
								{t('pages.home.events.dateCounter', { daysCount: dayjs(entertainment.dateStart).diff(dayjs(), 'd') })}
							</Text>
						</Box>
				}
			</Center>
		</Card.Root>
	);
}

export default EntertainmentCard;